<template>
  <div>
    <!-- <v-row class="row-menu-right mb-3 pl-3 pr-3">
      <v-btn
        rounded
        color="success"
        dark
        class="mt-2"
        @click="gotocreate"
      >
      <v-icon left dark color="white">fa-plus-circle</v-icon>
      Create
      </v-btn>
      <v-btn
        rounded
        color="blue-grey"
        dark
        class="mt-2 ml-2"
      >
      <v-icon left dark color="white">mdi-cloud-upload</v-icon>
      Import
      </v-btn>
      <v-btn
        rounded
        color="#2196F3"
        dark
        class="mt-2 ml-2"
      >
      <v-icon left dark color="white" small>fa-file-export</v-icon>
      Export
      </v-btn>
    </v-row> -->
    <OverlayLoading :loading="loading" />
    <v-data-table
      :headers="headerSetting"
      :items="employeeData"
      class="border-table-employee text-no-wrap mt-1"
      item-key="no"
      :single-expand="singleExpand"
      :expanded.sync="expanded"
      show-expand
      :loading="loading"
      loader-height=0
      loading-text="Loading... Please wait"
      :footer-props="{
        'items-per-page-options': [15, 30, 50, 100, -1],
        'items-per-page': 15
      }"
      :server-items-length="total || -1"
      @update:items-per-page="changePerPage"
      @update:page="changePage"
      disable-sort
      :page.sync="page"
      :items-per-page="perPage"
      hide-default-footer
      @page-count="pageCount = $event"
    >
      <template v-slot:[`item.no`]="{ item }">
        {{ (perPage*(page-1)) + employeeData.indexOf(item)+1 }}
      </template>
      <template v-slot:[`group.header`]="{ group, headers, toggle, isOpen }">
        <td :colspan="headers.length">
            <v-btn @click="toggle" small icon :ref="group" :data-open="isOpen">
                <v-icon v-if="isOpen">mdi-chevron-up</v-icon>
                <v-icon v-else>mdi-chevron-down</v-icon>
            </v-btn>
            ชื่อ-สกุล: {{ group }}
        </td>
      </template>
      <!-- ปิดไว้ก่อน -->
      <!-- <template v-slot:[`item.userImg`]="{ item }">
        <td style="width: fit-content !important;" class="py-2">
          <v-avatar
            size="44"
            rounded
          >
            <v-img
              :lazy-src="require('@/assets/icons/no_user.png')"
              :src="item.failed_image ? require('@/assets/icons/no_user.png') : item.userImg"
              :alt="item.employeeId"
              v-on:error="onImgError(item.no-1)"
            />
          </v-avatar>
        </td>
      </template> -->
      <!-- end -->
      <template v-slot:[`item.actions`]="{ item }">
        <v-row class="d-flex ">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  dark
                  icon
                  tile
                  class="ml-7"
                  @click="editPage(item)">
                   <template v-slot>
                    <v-icon small dark class="icon-eye-color">mdi-pencil-outline</v-icon>
                  </template>
                </v-btn>
              </template>
              <span class="label-table-action">จัดการพนักงาน</span>
            </v-tooltip>
            <!-- <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  dark
                  icon
                  tile
                  class=""
                  @click="checkRemove(item)">
                  <template v-slot>
                    <v-icon small >mdi-delete-outline</v-icon>
                  </template>
                </v-btn>
              </template>
              <span class="label-table-action" color="error">ลบพนักงาน</span>
            </v-tooltip> -->
        </v-row>
      </template>
      <template v-slot:[`item.data-table-expand`]="{ expand, isExpanded, item }">
        <v-row class="d-flex">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  dark
                  icon
                  tile
                  class="ml-10"
                  @click="editPage(item)">
                  <template v-slot>
                    <v-icon small dark class="icon-eye-color">mdi-pencil-outline</v-icon>
                  </template>
                </v-btn>
              </template>
              <span class="label-table-action">จัดการพนักงาน</span>
            </v-tooltip>
            <!-- <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  dark
                  icon
                  tile
                  class="mr-2"
                  @click="checkRemove(item)">
                  <template v-slot>
                    <v-icon small color="error">mdi-delete-outline</v-icon>
                  </template>
                </v-btn>
              </template>
              <span class="label-table-action">ลบพนักงาน</span>
            </v-tooltip> -->
            <v-btn
              v-if="item.children.length !== 0"
              class=""
              text
              icon
              v-show="item.children"
              @click="expand(!isExpanded)"
            >
              <v-icon v-if="!isExpanded">mdi-chevron-down</v-icon>
              <v-icon v-else>mdi-chevron-up</v-icon>
            </v-btn>
        </v-row>
      </template>
      <!-- <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" class="mt-5 mb-5 pb-2" style="background-color: #F5F5F5;">
          <div v-for="(other, i) in item.orgChart" :key="i" class="">
            <td>{{other.NameTh}}</td>
            <hr>
          </div>
        </td>
      </template> -->
      <!-- <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="1" v-for="(headname, i) in headers" :key="i" style="background-color: #F5F5F5;">
          <div v-for="(other, j) in item.orgChart" :key="j" class="row mt-5 mb-5 pb-2" style="margin-left: 0px;">
            <td v-if="![0,1,7].includes(i)">{{other[headname.value]}}</td>
          </div>
        </td>
      </template> -->
      <!-- <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" class="ma-0">
        <v-simple-table class="" style="border-radius: 0px; background-color: #F5F5F5;
        margin-left: -16px;">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>Dessert (400g serving)</th>
                    <th>Calories</th>
                    <th>Fat</th>
                    <th>Carbs</th>
                    <th>Protein</th>
                    <th>Iron</th>
                    <th>Protein</th>
                    <th>Iron</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(other, j) in item.orgChart" :key="j">
                    <td :colspan="1">1</td>
                    <td :colspan="1">2</td>
                    <td :colspan="1">{{ other.NameTh }}</td>
                    <td>{{ other.employeeType }}</td>
                    <td>{{ other.employeeType }}</td>
                    <td>{{ other.position }}</td>
                    <td>{{ other.orgChartHeader }}</td>
                    <td>x</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </td>
      </template> -->
      <!-- <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" class="ma-0" style="width: 100%;">
          <v-data-table
          class="row"
            :headers="[
            {
              text: 'ลำดับ',
              align: 'start',
              value: 'no',
              width: '70px'
            },
            { text: 'รูปภาพ', value: 'userImg', width: '75px' },
            { text: 'ชื่อ - นามสกุล', value: 'NameTh', width: '212px' },
            { text: 'รหัสพนักงาน', value: 'employeeId', width: '212px' },
            { text: 'ประเภทพนักงาน', value: 'employeeType', width: '212px' },
            { text: 'ตำแหน่ง', value: 'position', width: '20%' },
            { text: 'สายบังคับบัญชา', value: 'orgChartHeader', divider: true, width: '212px' },
            { text: 'จัดการ', value: 'data-table-expand', sortable: false, width: '140px', align: 'start fixed', class: 'column-fix' }
            ]
            "
            :items="item.orgChart"
            hide-default-footer
            hide-default-header
          ></v-data-table>
        </td>
      </template> -->
      <template v-slot:expanded-item="{ headers, item }">
        <!-- {{item.children.length}} -->
        <td :colspan="headers.length" style="background-color: #F5F5F5;" v-if="item.children.length !== 0">
            <div class="row" style="background-color: #F5F5F5;">
              <v-simple-table class="" style="width:100%; border-radius: 0px; background-color: #F5F5F5;">
              <template v-slot:default>
                <!-- v-if="item.children.length !== 0" -->
                <tbody >
                  <!-- <tr v-for="(other, j) in item.children" :key="j">
                    <td style="width:70px;"></td>
                    <td style="width:75px;"></td>
                    <td style="width:212px;" align="left">{{ other.NameTh }}</td>
                    <td style="width:100px;" align="left">{{ other.employeeId }}</td>
                    <td style="width:200px;" align="left">{{ other.employeeStatusText }}</td>
                    <td style="width:200px;" align="left">{{ other.position }}</td>
                    <td style="width:200px;" align="left">{{ other.orgChartHeader || 'สายงานกรรมการบริหาร' }}</td>
                    <td style="width:100px;" align="left">{{ other.companyName }}</td>
                    <td style="width:100px;" align="left">{{ other.emailOneId }}</td>
                    <td style="width:300px;"></td>
                  </tr> -->
                  <tr v-for="(other, j) in item.children" :key="j">
                    <td style="width:70px;"></td>
                    <td style="width:75px;"></td>
                    <td style="width:212px;" align="left">{{ other.NameTh }}</td>
                    <td style="width:100px;" align="left">{{ other.employeeId }}</td>
                    <td style="width:200px;" align="left">{{ other.employeeStatusText }}</td>
                    <td style="width:180px;" align="left">{{ other.position }}</td>
                    <td style="width:220px;" align="left">{{ other.orgChartHeader || '' }}</td>
                    <td style="width:320px;" align="left">{{ other.companyName }}</td>
                    <td style="width:100px;" align="left">{{ other.emailOneId }}</td>
                    <td style="width: 0px;"></td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            </div>
        </td>
    </template>
    </v-data-table>
    <v-row>
        <v-col cols="12" class="pa-0">
        <div class="justify-end d-flex align-end pt-4">
          <v-pagination
            v-model="page"
            :length="pageCount"
            :total-visible="5"
          ></v-pagination>
        </div>
        </v-col>
      </v-row>
    <v-dialog v-model="dialogDeleteEmployee" max-width="500px">
        <v-card height="170px">
          <v-card-title class="icon-eye-color ra-head-text-bold justify-center pa-5">ต้องการลบข้อมูลนี้ ใช่หรือไม่?</v-card-title>
          <v-card-text class="justify-center text-center">
          <span class="ra-head-text justify-center">คุณแน่ใจหรือว่าต้องการลบข้อมูลนี้</span>
          </v-card-text>
          <v-card-actions class="">
            <v-spacer></v-spacer>
            <v-btn class="button-color-outline" outlined @click="dialogDeleteEmployee = false">ยกเลิก</v-btn>
            <v-btn class="button-color" dark @click="removeApprover()">ลบข้อมูล</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <div class="text-center">
        <v-snackbar
          v-model="snackbar"
          :timeout="timeout"
          :color="snackbarColor"
          absolute
          text
          top
          app
        >
        <v-icon left dark small :color="snackbarColor">fa-check-circle</v-icon>
        <span :style="{ 'color': `${snackbarColor}` }">{{ text }}</span>
        </v-snackbar>
      </div>
  </div>
</template>

<script>
import {
  getEmployeeListCurrent,
  getCompanyFilter,
  // getImg,
  hostImageUrlv3,
  deleteEmployee
} from '@/API/API'
import { OverlayLoading } from '@/components/index'
import FileSaver from 'file-saver'
import { EventBus } from '@/EventBus'
import moment from 'moment'

export default {
  components: {
    OverlayLoading
  },
  data () {
    return {
      dialogDeleteEmployee: false,
      multiLine: true,
      snackbar: false,
      timeout: 2000,
      snackbarColor: '',
      text: '',
      expanded: [],
      singleExpand: true,
      togglers: {},
      itemConfirmDelete: [],
      keywordworkName: [],
      keywordCompanyName: '',
      keywordHeader: '',
      keywordGroupCompanyName: '',
      keywordUserName: '',
      keywordUserPosition: '',
      keywordHeaderName: '',
      keywordEmployeeId: '',
      tab: 'all',
      loading: true,
      total: -1,
      pageCount: 0,
      perPage: 15,
      page: 1,
      failed_image: false,
      tokenUser: '',
      itemTestChildren: [{
        companyName: 'INET CNX',
        position: 'Tester',
        orgChartName: 'บริหาร หารเงิน',
        orgChartHeader: 'กรรมการ การเงิน'
      },
      {
        companyName: 'INET KKC',
        position: 'Support',
        orgChartName: 'บริหาร บุคคล',
        orgChartHeader: 'กรรมการ'
      }
      ],
      headerSetting: [
        {
          text: 'ลำดับ',
          align: 'start',
          value: 'no',
          width: '70px'
        },
        // { text: 'รูปภาพ', value: 'userImg', width: '75px' }, // ปิดไว้ก่อน
        { text: 'ชื่อ - นามสกุล', value: 'nameTh', width: '212px' },
        { text: 'รหัสพนักงาน', value: 'employeeId', width: '100px' },
        // { text: 'ประเภทพนักงาน', value: 'employeeStatusText', width: '200px' },
        { text: 'ตำแหน่ง', value: 'position', width: '100px' },
        { text: 'แผนก', value: 'orgChartHeader', width: '200px' },
        { text: 'บริษัท', value: 'companyName', width: '100px' },
        { text: 'อีเมล', value: 'emailOneId', width: '100px', divider: true },
        // { text: 'E-mail', value: 'emailOneId' },
        // { text: 'จัดการ', value: 'actions', sortable: false, width: '100px', class: 'col-fix', align: 'center fixed' },
        { text: 'จัดการ', value: 'data-table-expand', sortable: false, width: '130px', align: 'center fixed', class: 'column-fix' }
      ],
      mockup: [],
      selectData: [],
      employeeData: []
    }
  },
  created () {
    this.loading = true
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.tokenUser = this.$store.state.token
    try {
      this.initData()
    } catch (error) {
    } finally {
      // this.loading = false
    }
  },
  mounted () {
    // downloadFile
    EventBus.$on('filterCurrent', this.getSelect)
    EventBus.$on('downloadFileCurrent', this.downloadFile)
    EventBus.$on('closedialogUploadFile', this.initData)
  },
  beforeDestroy () {
    EventBus.$off('filterCurrent')
    EventBus.$off('downloadFileCurrent')
    EventBus.$off('closedialogUploadFile')
  },
  methods: {
    formatDate (date) {
      return date ? moment(date).format('DD/MM/YYYY') : 'ไม่มี'
    },
    onImgError (i) {
      this.employeeData[i].failed_image = true
    },
    changePerPage (value) {
      this.perPage = value
      this.initDataTable()
    },
    changePage (value) {
      this.page = value
      this.initDataTable()
    },
    getSelect (data) {
      this.keywordEmployeeId = data.employeeId
      this.keywordworkName = data.name
      this.keywordCompanyName = data.companyName
      this.keywordHeader = data.header
      this.keywordGroupCompanyName = data.groupCompany
      this.keywordHeaderName = data.orgChartHeader
      this.keywordUserPosition = data.position
      this.tab = data.tab
      this.total = -1
      this.perPage = 15
      this.page = 1
      this.initDataTable()
    },
    checkRemove (item) {
      this.itemConfirmDelete = []
      this.itemConfirmDelete = item
      this.dialogDeleteEmployee = true
    },
    async removeApprover (item) {
      try {
        const res = await deleteEmployee(this.itemConfirmDelete.userId, this.$store.state.token)
        if (res.success) {
          this.text = 'คุณได้ทำการลบข้อมูลเรียบร้อยแล้ว'
          this.snackbar = true
          this.snackbarColor = 'success'
          this.dialogDeleteEmployee = false
          this.itemConfirmDelete = []
          this.initData()
        } else {
          this.text = 'กรุณาลองใหม่อีกครั้ง'
          this.snackbar = true
          this.snackbarColor = 'error'
        }
      } catch (error) {
        console.log(error)
        this.text = 'ไม่สามารถลบได้ กรุณาลองใหม่อีกครั้ง'
        this.snackbar = true
        this.snackbarColor = 'error'
      }
      // this.text = 'คุณได้ทำการลบข้อมูลผู้อนุมัติเรียบร้อยแล้ว'
      // this.snackbar = true
    },
    initData () {
      this.initDataTable()
      this.getCompanyFilter()
    },
    async getCompanyFilter () {
      const token = this.tokenUser
      try {
        const res = await getCompanyFilter(token)
        if (res.success) {
          if (res.result.length) {
            // this.selectData = res.result
          }
        } else {
          // console.log(res)
        }
        // EventBus.$emit('selectCompany', res.result)
      } catch (error) {
        // alert(error)
        // console.log(error)
      } finally {
        // this.loading = false
      }
    },
    async initDataTable () {
      this.loading = true
      this.employeeData = []
      const temp = []
      var obj = {
        employeeId: this.keywordEmployeeId,
        name: this.keywordworkName,
        company: this.keywordCompanyName,
        header: this.keywordHeader,
        groupCompany: this.keywordGroupCompanyName,
        orgChartHeader: this.keywordHeaderName,
        position: this.keywordUserPosition,
        tab: this.tab,
        limit: this.perPage,
        page: this.page
      }

      try {
        const res = await getEmployeeListCurrent(obj, this.tokenUser)
        if (res.success) {
          if (res.result.length) {
            // res.result.sort((a, b) => { return a.NameTh.localeCompare(b.NameTh) }).map(async function (el, index) {
            //   temp.push({
            //     no: index + 1,
            //     failed_image: false,
            //     ...el
            //   })
            // })
            res.result.map((el, index) => {
              if (el.userImg === '') {
                el.userImg = `${hostImageUrlv3}/_/${el.emailOneId}`
              } else {
                el.userImg = `${hostImageUrlv3}/${el.userImg}/${el.emailOneId}`
              }
              temp.push({
                no: index + 1,
                failed_image: false,
                ...el
              })
            })
            if (this.tab === 'กรุงเทพฯ') {
              this.total = res.countBangkok || -1
            } else if (this.tab === 'เชียงใหม่') {
              this.total = res.countChiangMai || -1
            } else if (this.tab === 'หาดใหญ่') {
              this.total = res.countHatYai || -1
            } else if (this.tab === 'ขอนแก่น') {
              this.total = res.countKhonKaen || -1
            } else if (this.tab === 'สระบุรี') {
              this.total = res.countSaraburi || -1
            } else if (this.tab === 'นครราชสีมา') {
              this.total = res.countNakhonRatchasima || -1
            } else if (this.tab === 'ประจำโรงพยาบาล') {
              this.total = res.countHospital || -1
            } else {
              this.total = res.totalCount || -1
            }
            this.employeeData = temp
          }
          EventBus.$emit('updateTabCountCurrent', { total: res.totalCount, countBangkok: res.countBangkok, countChiangMai: res.countChiangMai, countHatYai: res.countHatYai, countKhonKaen: res.countKhonKaen, countSaraburi: res.countSaraburi, countNakhonRatchasima: res.countNakhonRatchasima, countHospital: res.countHospital })
          this.isLoading = false
        } else {
          // console.log('Res', res)
        }
      } catch (error) {
        // alert(error)
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async downloadFile () {
      this.loading = true
      let query = '?status=current'

      if (this.keywordworkName.length > 0) {
        query += `&name=${this.keywordworkName}`
      }
      if (Array.isArray(this.keywordCompanyName) && this.keywordCompanyName.length > 0) {
        query += `&company=${this.keywordCompanyName.toString()}`
      }
      if (this.tab !== '' || this.tab !== null) {
        query += `&tab=${this.tab}`
      }

      await this.axios({
        method: 'get',
        responseType: 'blob',
        url: `${this.api}/api/vMonk/users/download${query}`,
        headers: {
          authorization: this.tokenUser
        }
        // url: `${this.api}/uploads/companyFile/fileposition.xlsx`
      }).then((response) => {
        const date = moment().format('DD-MM-YYYY_HH-mm-ss_')
        FileSaver.saveAs(new Blob([response.data]), `${date}ไฟล์ข้อมูลพนักงานปัจจุบัน.xlsx`)
        this.loading = false
      }).catch(e => {
        console.log(e)
        this.loading = false
      })
    },
    editPage (data) {
      var tabValue = 'employee/'
      this.$router.push('manageemployee/update/' + tabValue + data.userId)
      // this.$router.push({
      //   name: 'manageEmployeeUpdate',
      //   params: {
      //     item: data,
      //     id: data._id,
      //     tab: 'employee'
      //   }
      // })
    },
    manageLineWork (data) {
      // console.log('manage Employee', data)
    },
    gotocreate () {
      this.$router.push('manageemployee/create')
    }
  }
}
</script>

<style>
/* table */
.theme--light.v-pagination .v-pagination__item--active {
    background: #2BA197 !important;
    color: #FFFFFF;
}
.v-pagination__item {
    background: transparent;
    border-radius: 4px;
    font-size: 14px;
    height: 30px;
    margin: 0.3rem;
    min-width: 30px;
    padding: 0 5px;
    text-decoration: none;
    transition: 0.3s cubic-bezier(0, 0, 0.2, 1);
    width: auto;
    box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
}
.v-pagination__navigation {
    box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    height: 30px;
    width: 30px;
    margin: 0.3rem 10px;
}
/* end */
.border-table-employee {
  border-radius: 10px;
  border: 1px solid rgb(229, 236, 238);
}

table > tbody > tr > td.fixed:nth-last-child(1),
table > thead > tr > th.fixed:nth-last-child(1) {
  position: sticky !important;
  position: -webkit-sticky !important;
  right: 0;
  /* z-index: 9997; */
  background: white;
  /* background: transparent; */
  -webkit-box-shadow: -1px 0px 3px -1px rgba(0, 0, 0, 0.19);
  -moz-box-shadow: -1px 0px 3px -1px rgba(0, 0, 0, 0.19);
  box-shadow: -1px 0px 3px -1px rgba(0, 0, 0, 0.19);
}

table > tbody > tr:hover > td.fixed:nth-last-child(1), table > thead > tr:hover > th.fixed:nth-last-child(1) {
  background: #eeeeee;
}

table > thead > tr > th.fixed:nth-last-child(1) {
  /* z-index: 9998; */
  background-color: #F8F9FB;
}

</style>

<style scoped>
.v-data-table {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 16px;
}
.row-menu-left {
  justify-content: flex-start !important;
}
.row-menu-right {
  justify-content: flex-end !important;
}
.v-data-table tbody tr.v-data-table__expanded__content {
  box-shadow: inset 0px 4px 8px -5px rgba(50, 50, 50, 0), inset 0px -4px 8px -5px rgba(50, 50, 50, 0) !important;
}
.padding-left-90 {
  padding-left: 90px !important;
}
.table-name-row {
  display: flex;
  flex-direction: row;
}
.btn-edit-dep {
  background-color: #0370B7 !important;
  color: #fff !important;
}
.btn-del-dep {
  background-color: #da2525 !important;
  color: #fff !important;
}
</style>
